import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ProfessionalRfpProposalListStatus } from '@/components/modules/pages/mypage/professional/List/ProfessionalRfpProposalList/ActionStatus';
import { CircleCheckIcon, CircleStopOutlineIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { VIEW_REQUEST_PROPOSAL_UNREGISTERED } from '@/utils/constants/viewRequest/proposal';
export const ProfessionalRfpProposalListProposalStatus = (props) => {
    const { proposal } = props;
    if (proposal === VIEW_REQUEST_PROPOSAL_UNREGISTERED.value) {
        return (_jsx(ProfessionalRfpProposalListStatus, Object.assign({ icon: CircleStopOutlineIcon, iconColor: 'error', textColor: 'error' }, { children: "\u672A\u767B\u9332" })));
    }
    return (_jsx(ProfessionalRfpProposalListStatus, Object.assign({ icon: CircleCheckIcon, iconColor: 'inactive', textColor: 'inactive' }, { children: "\u767B\u9332\u6E08" })));
};
